<h2 mat-dialog-title>Enable Channel For Marketing</h2>

<mat-dialog-content class="content">

  <div class="info-detail">This communication channel has not been enabled for marketing. This means that this customer
    is
    <strong>not</strong> contacted by the below contact method for marketing purposes.
  </div>

  <div class="contact-details-container">

    <div class="channel">
      <span class="channel-icon material-icons">
        {{getChannelIcon(data.channel)}}
      </span>
      {{data.Channel}} &nbsp;&nbsp;
      <span *ngIf="data.channel == 'Mail'" class="value"> E-mail</span>
      <span *ngIf="data.channel == 'SMS'" class="value"> Mobile Phone - SMS</span>
      <span *ngIf="data.channel == 'Call'" class="value"> Phone - Calls</span>

    </div>

    <span class="value">
      
      {{data.value}}
    </span>

  </div>


  <div class="subtitle">Choose an option below:</div>

  <div class="action-container">

    <div class="cancel-container">
      <button mat-fab extended class="cancel-btn" (click)="close()">
        <mat-icon>close</mat-icon>
        Cancel
      </button>
    </div>
    <div class="consent-confirmation-container">
      <button mat-fab extended class="optout-btn" (click)="enableConsent(data.channel, data.value, 'optout')">
        <mat-icon>logout</mat-icon>
        Enable & Opt Out
      </button>

      <button mat-fab extended class="optin-btn" (click)="enableConsent(data.channel, data.value, 'optin')">
        <mat-icon>login</mat-icon>
        Enable & Opt In
      </button>
    </div>
  </div>







</mat-dialog-content>

<!-- <mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions> -->